<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container">
      <b-card>
        <div class="row">
          <div class="col-lg-6 text-left">
            <h1>User Search</h1>
            <b-input-group>
              <b-input id="filter" v-model="filter" placeholder="Search" />
              <b-input-group-button @click="searchList()" class="btn btn-secondary btn-search">Search</b-input-group-button>
            </b-input-group>
          </div>
          <div class="col-lg-6 text-right">
            <b-button @click="downloadCSV()" :disabled="downloading" class="btn btn-white"><font-awesome-icon icon="download" /> Download CSV</b-button>
          </div>
        </div>
      </b-card>
    </div>
    <div class="container text-left">
      <div class="row">
        <div class="col-lg-12">
          <b-card>
            <div v-if="$store.state.users.sort.field" class="text-center mb-2 sort-wrapper">
              <span>
                Sorting By: <b>{{ sortField }}</b
                >, Sort Direction: <b>{{ $store.state.users.sort.direction === 'ASC' ? 'Ascending' : 'Descending' }}</b>
              </span>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th @click="sort('first_name')">First Name <font-awesome-icon icon="sort" /></th>
                    <th @click="sort('last_name')">Last Name <font-awesome-icon icon="sort" /></th>
                    <th @click="sort('email')">Email <font-awesome-icon icon="sort" /></th>
                    <th>Organizations</th>
                    <th @click="sort('sign_in_count')" class="signin-count">Sign In Count <font-awesome-icon icon="sort" /></th>
                    <th @click="sort('last_sign_in_at')">Last Sign In <font-awesome-icon icon="sort" /></th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in $store.state.users.list" :key="user._id">
                    <td>{{ user.first_name }}</td>
                    <td>{{ user.last_name }}</td>
                    <td>
                      <router-link :to="{ name: 'users detail', params: { userId: user._id } }">{{ user.email }}</router-link>
                    </td>
                    <td>
                      <span v-for="org in user.organizations" :key="org._id">{{ org.name }} </span>
                    </td>
                    <td class="count">{{ user.sign_in_count }}</td>
                    <td>{{ user.last_sign_in_at | dateOnly }}</td>
                    <td>
                      <router-link :to="{ name: 'users edit', params: { userId: user._id } }" class="btn btn-secondary">Edit</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination justify-content-end mt-5">
              <div class="total-count">Total Records: {{ $store.state.users.fullCount ? $store.state.users.fullCount.toLocaleString() : 0 }}</div>
              <b-pagination
                v-if="$store.state.users.fullCount > 0"
                :value="$store.state.users.page.page"
                :total-rows="$store.state.users.fullCount"
                :per-page="$store.state.users.page.pageSize"
                :hide-ellipsis="true"
                @change="changePage"
              />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      filter: '',
      sortField: '',
      displayMap: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        sign_in_count: 'Sign In Count',
        last_sign_in_at: 'Last Sign In',
      },
      downloading: false,
      Breadcrumbs: [
        {
          text: 'Dashboard',
          active: false,
          href: '/admin',
        },
        {
          text: 'Partners',
          active: true,
        },
        {
          text: 'Users',
          active: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('users/getUsers');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    sort(field) {
      try {
        this.isLoading = true;
        this.$store.dispatch('users/sortUsers', field);
        this.sortField = this.displayMap[this.$store.state.users.sort.field];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async changePage(page) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('users/setPage', page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    searchList() {
      try {
        this.isLoading = true;
        this.$store.dispatch('users/setFilter', this.filter);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async downloadCSV() {
      let url = `${process.env.VUE_APP_API_USERS_ROOT}/users?csv=true`;
      const st = this.$store.state.organizations;
      if (st.sort.field) {
        url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
      }
      if (st.filter && st.filter !== '') {
        url += `&filtering=true&filter=${st.filter}`;
      }

      try {
        document.body.style.cursor = 'wait';
        this.downloading = true;
        await axios({
          method: 'get',
          url,
          responseType: 'blob',
        }).then((response) => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url2;
          link.setAttribute('download', 'users.csv'); // or any other extension
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.downloading = false;
        document.body.style.cursor = 'default';
      }
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0px 0 20px 0;
}
th {
  cursor: pointer;
}
td.count {
  text-align: center;
}
.signin-count {
  min-width: 130px;
  text-align: center;
}
.total-count {
  padding: 0px 20px 0px 0px;
  line-height: 35px;
}
.card {
  border: none;
}
.sort-wrapper span {
  background-color: #f5ecca;
  padding: 5px 10px;
  border-radius: var(--rounded-md);
  margin-bottom: 5px;
  display: inline-block;
}
th.sort span {
  cursor: pointer;
}
.fa-sort {
  color: #ccc;
}
table thead th {
  white-space: nowrap;
}
</style>
